var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/palette.ts
var palette_exports = {};
__export(palette_exports, {
  alphaSlate: () => alphaSlate,
  alphaWhite: () => alphaWhite,
  cerulean: () => cerulean,
  data: () => data,
  green: () => green,
  magenta: () => magenta,
  mauve: () => mauve,
  neutrals: () => neutrals,
  orange: () => orange,
  pink: () => pink,
  purple: () => purple,
  red: () => red,
  sand: () => sand,
  slateBlue: () => slateBlue,
  teal: () => teal,
  yellow: () => yellow
});
var neutrals = {
  white: "#FFFFFF",
  coolGrey1: "#FCFCFD",
  coolGrey2: "#F9F9FB",
  coolGrey3: "#F3F3F7",
  coolGrey4: "#EBEBF1",
  coolGrey5: "#DCDEEA",
  coolGrey6: "#D0D2DD",
  coolGrey7: "#B9BBC6",
  coolGrey8: "#A2A3AC",
  coolGrey9: "#8B8D98",
  coolGrey10: "#6F737B",
  coolGrey11: "#60646C",
  coolGrey12: "#15191E",
  black: "#101317",
  pitchBlack: "#000000"
};
var alphaSlate = {
  1: "rgba(192, 200, 211, 0.05)",
  2: "rgba(151, 150, 182, 0.06)",
  3: "rgba(84, 87, 142, 0.07)",
  4: "rgba(46, 57, 92, 0.10)",
  5: "rgba(66, 87, 138, 0.15)",
  6: "rgba(97, 106, 136, 0.30)",
  7: "rgba(52, 59, 91, 0.35)",
  8: "rgba(98, 103, 117, 0.60)",
  9: "rgba(90, 93, 107, 0.70)",
  10: "rgba(74, 80, 90, 0.8)",
  11: "rgba(78, 83, 92, 0.9)",
  12: "rgba(78, 83, 92, 0.95)"
};
var alphaWhite = {
  1: "rgba(255, 255, 255, 0.05)",
  2: "rgba(255, 255, 255, 0.06)",
  3: "rgba(255, 255, 255, 0.07)",
  4: "rgba(255, 255, 255, 0.10)",
  5: "rgba(255, 255, 255, 0.15)",
  6: "rgba(255, 255, 255, 0.30)",
  7: "rgba(255, 255, 255, 0.35)",
  8: "rgba(255, 255, 255, 0.60)",
  9: "rgba(255, 255, 255, 0.70)",
  10: "rgba(255, 255, 255, 0.80)",
  11: "rgba(255, 255, 255, 0.90)",
  12: "rgba(255, 255, 255, 0.95)"
};
var sand = {
  1: "#FBF2E9",
  2: "#F7E9D9",
  3: "#ECD5BB",
  4: "#DDB699",
  5: "#CCA689",
  6: "#B39279",
  7: "#967A64",
  8: "#7E6653",
  9: "#5D4A3B",
  10: "#45372C",
  11: "#342921",
  12: "#251D17"
};
var pink = {
  1: "#F6E2F6",
  2: "#F2D0F4",
  3: "#FABEFB",
  4: "#F1A4F3",
  5: "#DF83E2",
  6: "#D364D7",
  7: "#CD39D2",
  8: "#9A1E9F",
  9: "#7E0382",
  10: "#620C65",
  11: "#4F0251",
  12: "#340336"
};
var magenta = {
  1: "#FDECEF",
  2: "#FBD5DD",
  3: "#FAB7C5",
  4: "#F991AA",
  5: "#FB658D",
  6: "#FF3273",
  7: "#FF0162",
  8: "#CE0060",
  9: "#9D0059",
  10: "#6D004C",
  11: "#410037",
  12: "#19001A"
};
var mauve = {
  1: "#F1EBED",
  2: "#E6E0E2",
  3: "#D7CFD2",
  4: "#C9BFC3",
  5: "#C1B4B9",
  6: "#B8A5AC",
  7: "#AB969E",
  8: "#A18A94",
  9: "#907882",
  10: "#7B646D",
  11: "#644F58",
  12: "#45363C"
};
var purple = {
  1: "#F4F3FF",
  2: "#E6E2FF",
  3: "#D1C6FF",
  4: "#BDADFF",
  5: "#957BFF",
  6: "#7756FF",
  7: "#582FFF",
  8: "#3C16D5",
  9: "#3112AF",
  10: "#240C84",
  11: "#100052",
  12: "#0A012D"
};
var slateBlue = {
  1: "#F5F7FB",
  2: "#E6EDF5",
  3: "#CCDAEB",
  4: "#B3C8E1",
  5: "#80A4CE",
  6: "#6691C4",
  7: "#336DB0",
  8: "#195AA6",
  9: "#00418C",
  10: "#00326D",
  11: "#001D3E",
  12: "#000710"
};
var cerulean = {
  1: "#ECF4FD",
  2: "#D5E8FB",
  3: "#B7D8FA",
  4: "#91C4F9",
  5: "#65ADFB",
  6: "#3293FF",
  7: "#006EF5",
  8: "#005ACE",
  9: "#00419D",
  10: "#002A6D",
  11: "#001741",
  12: "#000D29"
};
var teal = {
  1: "#E4FBF2",
  2: "#DCF6EC",
  3: "#C8F6E4",
  4: "#B2F3E1",
  5: "#90EFDE",
  6: "#76E0CD",
  7: "#50CFBA",
  8: "#3CBCA7",
  9: "#2A9F90",
  10: "#18796C",
  11: "#0B5149",
  12: "#04342E"
};
var green = {
  1: "#F0FDF1",
  2: "#D1F4D2",
  3: "#B2EFB5",
  4: "#9CEB9F",
  5: "#80E284",
  6: "#6BD970",
  7: "#40D046",
  8: "#1EC425",
  9: "#0D9926",
  10: "#126E22",
  11: "#165020",
  12: "#0A2C10"
};
var yellow = {
  1: "#FDF9EC",
  2: "#FCEED6",
  3: "#FAE9B7",
  4: "#F9DF91",
  5: "#FBD565",
  6: "#FFCA32",
  7: "#FFBC01",
  8: "#CE9700",
  9: "#9D7100",
  10: "#6B4B00",
  11: "#4F3700",
  12: "#2D1F00"
};
var orange = {
  1: "#FEEFDE",
  2: "#FFE6CE",
  3: "#FFD09A",
  4: "#FFB258",
  5: "#FF8F28",
  6: "#FF7C1E",
  7: "#FF6B18",
  /** Brex brand orange */
  8: "#FF5900",
  9: "#FF3D00",
  10: "#ED2400",
  11: "#A40000",
  12: "#760000"
};
var red = {
  1: "#FFF0F2",
  2: "#FFE3E6",
  3: "#FFC8CF",
  4: "#F6ABB4",
  5: "#FD8C92",
  6: "#F46B6B",
  7: "#FF5353",
  8: "#EE2929",
  9: "#C50A0A",
  10: "#A40404",
  11: "#790000",
  12: "#490000"
};
var data = {
  1: "#AAA2F5",
  2: "#226B48",
  3: "#CAD63F",
  4: "#325994",
  5: "#71C5CE",
  6: "#7C6C22",
  7: "#36B08B",
  8: "#5B4383",
  9: "#CF729D",
  10: "#697E2A",
  11: "#5776E4",
  12: "#74475D",
  13: "#E0BF30",
  14: "#236270"
};

// src/colors.ts
var cerulean7 = "0,110,245";
var colors = {
  /**
   * @deprecated [Apr 18, 2024] These will soon be removed in favor of neutrals for DDA.
   *
   * Series of color to represent multiple Cash accounts. These are assigned in order when customers have at least 2 accounts. These should *only* be used in the context of differentiating between multiple Cash accounts. */
  cashAccount: {
    1: orange[8],
    2: cerulean[7],
    3: purple[9],
    4: pink[8],
    5: yellow[8],
    6: green[8],
    7: red[8],
    8: pink[10]
  },
  /**
   * Mobile app wave color (on the Wallet basement layer)
   */
  wave: {
    green: green[9],
    orange: orange[8],
    purple: purple[8]
  },
  /**
   * Focus states and focused borders
   */
  focus: `rgba(${cerulean7},.80)`,
  focusGlow: `rgba(${cerulean7},.35)`,
  focusPressed: cerulean[7],
  focusDisabled: `rgba(${cerulean7},.35)`,
  /**
   * Modal scrim color
   */
  overlay: "rgba(0,0,0,.35)",
  /**
   * @deprecated Use `"transparent"` directly instead.
   */
  transparent: "transparent"
};

// src/themes/dark.ts
var colors2 = {
  ...colors,
  accent: {
    primary: {
      background: {
        default: orange[8],
        pressed: orange[9],
        disabled: orange[10],
        muted: orange[12],
        hover: orange[7],
        focused: orange[9]
      },
      content: {
        default: neutrals.white,
        pressed: neutrals.white,
        disabled: orange[10],
        muted: neutrals.white
      }
    },
    pink: {
      background: {
        default: pink[8],
        pressed: pink[9]
      },
      content: {
        default: pink[1],
        pressed: pink[2],
        disabled: pink[2]
      }
    },
    blue: {
      background: {
        default: cerulean[9],
        pressed: cerulean[10]
      },
      content: {
        default: cerulean[1],
        pressed: cerulean[2],
        disabled: cerulean[2]
      }
    },
    purple: {
      background: {
        default: purple[8],
        pressed: purple[9]
      },
      content: {
        default: purple[1],
        pressed: purple[2],
        disabled: purple[2]
      }
    },
    green: {
      background: {
        default: green[8],
        pressed: green[9]
      },
      content: {
        default: green[1],
        pressed: green[2],
        disabled: green[2]
      }
    },
    yellow: {
      background: {
        default: yellow[8],
        pressed: yellow[9]
      },
      content: {
        default: yellow[1],
        pressed: yellow[2],
        disabled: yellow[2]
      }
    },
    red: {
      background: {
        default: red[8],
        pressed: red[9]
      },
      content: {
        default: red[1],
        pressed: red[2],
        disabled: red[2]
      }
    }
  },
  content: {
    primary: neutrals.coolGrey1,
    secondary: neutrals.coolGrey6,
    tertiary: neutrals.coolGrey9,
    disabled: neutrals.coolGrey11,
    inverse: {
      primary: neutrals.coolGrey12,
      secondary: neutrals.coolGrey11,
      tertiary: neutrals.coolGrey10,
      disabled: neutrals.coolGrey7
    }
  },
  background: {
    primary: neutrals.black,
    secondary: neutrals.coolGrey12,
    secondaryAlpha: alphaWhite[1],
    tertiary: neutrals.coolGrey11,
    tertiaryAlpha: alphaWhite[3],
    inverse: {
      primary: neutrals.white,
      secondary: neutrals.coolGrey2,
      tertiary: neutrals.coolGrey3
    }
  },
  positive: {
    default: green[8],
    hover: green[7],
    pressed: green[9],
    muted: green[12],
    ink: green[2],
    border: green[11]
  },
  warning: {
    default: yellow[8],
    hover: yellow[7],
    pressed: yellow[9],
    muted: yellow[12],
    ink: yellow[2],
    fill: yellow[7],
    border: yellow[11]
  },
  negative: {
    default: red[8],
    hover: red[7],
    pressed: red[9],
    muted: red[12],
    ink: red[2],
    border: red[11]
  },
  ai: {
    background: purple[12],
    backgroundDark: purple[12],
    hover: purple[11],
    content: {
      contained: purple[2],
      uncontained: purple[5]
    },
    border: {
      default: purple[9],
      hover: purple[7],
      pressed: purple[5]
    }
  },
  automation: {
    content: {
      contained: green[2],
      uncontained: green[7]
    },
    background: green[11],
    backgroundDark: green[12],
    fill: green[12],
    hover: green[12],
    border: {
      default: green[10],
      hover: green[8],
      pressed: green[6]
    }
  },
  sandbox: {
    content: {
      default: sand[2],
      hover: sand[3],
      pressed: sand[1]
    },
    background: sand[11]
  },
  copilot: {
    content: {
      default: slateBlue[2],
      hover: slateBlue[3],
      pressed: slateBlue[1]
    },
    background: slateBlue[11]
  },
  proAccess: {
    content: {
      default: neutrals.coolGrey12,
      hover: neutrals.coolGrey11,
      pressed: neutrals.black
    },
    background: neutrals.coolGrey8
  },
  selection: {
    default: cerulean[6],
    hover: cerulean[5],
    pressed: cerulean[7],
    disabled: neutrals.coolGrey11,
    background: alphaWhite[2],
    border: alphaWhite[5],
    borderDashed: {
      default: cerulean[9],
      hover: cerulean[7],
      pressed: cerulean[5],
      disabled: cerulean[10]
    }
  },
  banking: {
    checking: slateBlue[3],
    treasury: slateBlue[7],
    vault: slateBlue[11]
  },
  accountingSteps: {
    incomplete: slateBlue[11],
    prepare: slateBlue[9],
    review: slateBlue[6],
    exported: slateBlue[3]
  },
  policy: {
    approval: {
      hover: green[11],
      accent: green[6],
      ink: green[2]
    },
    documentation: {
      hover: slateBlue[10],
      accent: slateBlue[6],
      ink: slateBlue[2]
    },
    guidance: {
      hover: yellow[10],
      accent: yellow[6],
      ink: yellow[2]
    }
  },
  tableRow: {
    background: neutrals.black,
    hover: neutrals.coolGrey12,
    pressed: neutrals.coolGrey10,
    selected: {
      background: cerulean[12],
      hover: cerulean[11],
      pressed: cerulean[12]
    }
  },
  data: {
    1: data[1],
    2: data[2],
    3: data[3],
    4: data[4],
    5: data[5],
    6: data[6],
    7: data[7],
    8: data[8],
    9: data[9],
    10: data[10],
    11: data[11],
    12: data[12],
    13: data[13],
    14: data[14]
  },
  border: {
    default: alphaWhite[5],
    hover: alphaWhite[6],
    pressed: alphaWhite[7],
    focused: alphaWhite[7],
    disabled: alphaWhite[3],
    inverse: {
      default: alphaSlate[6],
      hover: alphaSlate[6],
      pressed: alphaSlate[7],
      focused: alphaSlate[7],
      disabled: alphaSlate[3]
    }
  },
  stencil: {
    default: alphaWhite[4],
    inverse: { default: alphaSlate[4] }
  }
};
var darkTheme = {
  colors: colors2
};

// src/themes/light.ts
var colors3 = {
  ...colors,
  accent: {
    primary: {
      background: {
        default: orange[8],
        hover: orange[7],
        pressed: orange[9],
        focused: orange[8],
        disabled: orange[4],
        muted: orange[1]
      },
      content: {
        default: neutrals.white,
        pressed: neutrals.white,
        disabled: orange[3],
        muted: orange[1]
      }
    },
    pink: {
      background: {
        default: pink[1],
        pressed: pink[2]
      },
      content: {
        default: pink[8],
        pressed: pink[10],
        disabled: pink[2]
      }
    },
    blue: {
      background: {
        default: cerulean[1],
        pressed: cerulean[2]
      },
      content: {
        default: cerulean[8],
        pressed: cerulean[10],
        disabled: cerulean[2]
      }
    },
    purple: {
      background: {
        default: purple[1],
        pressed: purple[2]
      },
      content: {
        default: purple[8],
        pressed: purple[10],
        disabled: purple[2]
      }
    },
    green: {
      background: {
        default: green[1],
        pressed: green[2]
      },
      content: {
        default: green[8],
        pressed: green[9],
        disabled: green[2]
      }
    },
    yellow: {
      background: {
        default: yellow[1],
        pressed: yellow[2]
      },
      content: {
        default: orange[7],
        pressed: orange[8],
        disabled: orange[2]
      }
    },
    red: {
      background: {
        default: red[1],
        pressed: red[2]
      },
      content: {
        default: red[8],
        pressed: red[10],
        disabled: red[2]
      }
    }
  },
  /**
   * Text and icon colors
   */
  content: {
    primary: neutrals.coolGrey12,
    secondary: neutrals.coolGrey11,
    tertiary: neutrals.coolGrey10,
    disabled: neutrals.coolGrey7,
    inverse: {
      primary: neutrals.coolGrey1,
      secondary: neutrals.coolGrey6,
      tertiary: neutrals.coolGrey9,
      disabled: neutrals.coolGrey11
    }
  },
  background: {
    primary: neutrals.white,
    secondary: neutrals.coolGrey2,
    secondaryAlpha: alphaSlate[2],
    tertiary: neutrals.coolGrey3,
    tertiaryAlpha: alphaSlate[3],
    inverse: {
      primary: neutrals.black,
      secondary: neutrals.coolGrey12,
      tertiary: neutrals.coolGrey10
    }
  },
  positive: {
    default: green[10],
    hover: green[9],
    pressed: green[11],
    muted: green[1],
    ink: green[11],
    border: green[3]
  },
  warning: {
    default: yellow[10],
    hover: yellow[9],
    pressed: yellow[11],
    muted: yellow[1],
    ink: yellow[11],
    fill: yellow[7],
    border: yellow[3]
  },
  negative: {
    default: red[10],
    hover: red[9],
    pressed: red[11],
    muted: red[1],
    ink: red[11],
    border: red[3]
  },
  ai: {
    content: {
      contained: purple[8],
      uncontained: purple[8]
    },
    background: purple[1],
    backgroundDark: purple[2],
    hover: purple[1],
    border: {
      default: purple[3],
      hover: purple[5],
      pressed: purple[7]
    }
  },
  automation: {
    content: {
      contained: green[10],
      uncontained: green[10]
    },
    background: green[1],
    backgroundDark: green[2],
    fill: green[2],
    hover: green[1],
    border: {
      default: green[3],
      hover: green[5],
      pressed: green[7]
    }
  },
  sandbox: {
    content: {
      default: sand[11],
      hover: sand[10],
      pressed: sand[12]
    },
    background: sand[2]
  },
  copilot: {
    content: {
      default: slateBlue[11],
      hover: slateBlue[10],
      pressed: slateBlue[12]
    },
    background: slateBlue[2]
  },
  proAccess: {
    content: {
      default: neutrals.coolGrey2,
      hover: neutrals.coolGrey3,
      pressed: neutrals.coolGrey1
    },
    background: neutrals.coolGrey12
  },
  banking: {
    checking: slateBlue[11],
    treasury: slateBlue[7],
    vault: slateBlue[3]
  },
  accountingSteps: {
    incomplete: slateBlue[1],
    prepare: slateBlue[3],
    review: slateBlue[6],
    exported: slateBlue[9]
  },
  policy: {
    approval: {
      hover: green[1],
      accent: green[9],
      ink: green[11]
    },
    documentation: {
      hover: slateBlue[1],
      accent: slateBlue[8],
      ink: slateBlue[10]
    },
    guidance: {
      hover: yellow[1],
      accent: yellow[7],
      ink: yellow[10]
    }
  },
  selection: {
    default: cerulean[10],
    hover: cerulean[9],
    pressed: cerulean[11],
    disabled: neutrals.coolGrey7,
    background: cerulean[1],
    border: cerulean[3],
    borderDashed: {
      default: cerulean[4],
      hover: cerulean[6],
      pressed: cerulean[8],
      disabled: cerulean[2]
    }
  },
  tableRow: {
    background: neutrals.white,
    hover: neutrals.coolGrey2,
    pressed: neutrals.coolGrey3,
    selected: {
      background: cerulean[1],
      hover: cerulean[2],
      pressed: cerulean[3]
    }
  },
  data: {
    1: data[1],
    2: data[2],
    3: data[3],
    4: data[4],
    5: data[5],
    6: data[6],
    7: data[7],
    8: data[8],
    9: data[9],
    10: data[10],
    11: data[11],
    12: data[12],
    13: data[13],
    14: data[14]
  },
  border: {
    default: alphaSlate[5],
    hover: alphaSlate[6],
    pressed: alphaSlate[7],
    focused: alphaSlate[7],
    disabled: alphaSlate[3],
    inverse: {
      default: alphaWhite[5],
      hover: alphaWhite[6],
      pressed: alphaWhite[7],
      focused: alphaWhite[7],
      disabled: alphaWhite[3]
    }
  },
  stencil: {
    default: alphaSlate[4],
    inverse: { default: alphaWhite[4] }
  }
};
var lightTheme = {
  colors: colors3
};

// src/animations.ts
var predefinedAnimations = {
  pulse: {
    durationMs: 750,
    animatedFields: {
      opacity: {
        from: 1,
        to: 0.5
      }
    }
  }
};
var animationDurationMs = {
  fast: 40,
  default: 80,
  slow: 180
};
var animations = {
  duration: {
    /**
     * Best duration preset for most contexts
     * */
    default: `${animationDurationMs.default}ms`,
    /**
     * Best for micro-interactions such as buttons, toggles, and quick fades
     * */
    fast: `${animationDurationMs.fast}ms`,
    /**
     * Best for animating large elements such as navigation menus, background dimming, and expressive motion
     * */
    slow: `${animationDurationMs.slow}ms`
  },
  /**
   * Default timing function to use for all animations that are not rendered using Framer Motion
   * */
  timingFunction: "cubic-bezier(0, 0, 0.38, 0.9)",
  predefinedAnimations
};

// src/borders.ts
var radius = {
  /**
   * Use for smaller elements such as popup menus.
   */
  small: 6,
  /**
   * Default radius setting. Use for most elements.
   */
  default: 10,
  /**
   * Use for very large elements such as modals.
   */
  large: 16,
  /**
   * Use when an element should be a circle. Sets `borderRadius` to `50%`.
   */
  circle: "50%",
  /**
   * Use whenever an element is shaped like a pill. The large number ensures that the pill shape is maintained even if the element size is large. Sets `borderRadius` to `9999`.
   */
  pill: 9999,
  /**
   * Presets specific to the predefined button sizes. *Do not use for other components.*
   */
  button: {
    /** Border radius for the `ButtonSize.TINY` button size. */
    tiny: 6,
    /** Border radius for the `ButtonSize.SMALL` button size. */
    small: 7,
    /** Border radius for the `ButtonSize.MEDIUM` button size. */
    medium: 8,
    /** @deprecated Border radius for the `ButtonSize.LARGE` button size. The `LARGE` button size has been deprecated and should not be used anymore. */
    large: 9
  }
};
var width = {
  default: 1,
  focus: 2
};
var borders = {
  width,
  radius
};

// src/shadows.ts
var shadows = {
  /**
   * Faint shadow style specific to secondary buttons and inputs.
   * */
  faint: "0 1px 1px rgba(0, 0, 0, 0.04)",
  /**
   * For cards and other box elements "laying flat" on a background
   */
  flat: "0px 1px 1px -2px rgba(16, 24, 40, 0.12), 0px 3px 2px -2px rgba(16, 24, 40, 0.11), 0px 0px 0px 1px rgba(16, 24, 40, 0.04)",
  /**
   * For previously flat elements that have been "lifted" off the surfaces, mostly for hover states (eg. hovering over a Card in Dashboard)
   */
  hover: "0px 0px 6px rgba(16, 24, 40, 0.05), 0px 6px 10px -4px rgba(16, 24, 40, 0.1), 0px 0px 2px 1px rgba(16, 24, 40, 0.02)",
  /**
   * For small elements that are floating in a fixed position above the rest of the UI, like menus, toasts, and buttons
   */
  floating: "0px 12px 20px -14px rgba(16, 24, 40, 0.09), 0px 4px 12px 2px rgba(16, 24, 40, 0.1), 0px 2px 4px -4px rgba(16, 24, 40, 0.14)",
  /**
   * For modals and dialog boxes, which tend to be larger and cast a larger shadow.
   */
  modal: "0px 14px 20px -11px rgba(16, 24, 40, 0.16), 0px 6px 20px 4px rgba(16, 24, 40, 0.12), 0px 4px 8px -8px rgba(16, 24, 40, 0.14)"
};

// src/spacing.ts
var spacing = {
  0: 0,
  2: 2,
  4: 4,
  8: 8,
  12: 12,
  16: 16,
  20: 20,
  24: 24,
  28: 28,
  32: 32,
  36: 36,
  40: 40,
  44: 44,
  48: 48,
  52: 52,
  56: 56,
  64: 64,
  96: 96
};

// src/typography.ts
var displayFontFamily = "Inter Display, Inter, -apple-system, BlinkMacSystemFont, Helvetica, Arial, sans-serif;";
var letterSpacingMultiplier = {
  /** Multiplier for Inter Regular */
  regular: 0.025,
  /** Multiplier for Inter Medium */
  medium: 0.02,
  /** Multiplier for Inter Semi Bold */
  semiBold: 0.01
};
var typography = {
  DetailLargeR: {
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: 400,
    letterSpacing: -12 * letterSpacingMultiplier.regular
  },
  DetailLargeM: {
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: 500,
    letterSpacing: -12 * letterSpacingMultiplier.medium
  },
  DetailLargeSB: {
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: 600,
    letterSpacing: -12 * letterSpacingMultiplier.semiBold
  },
  BodySmallR: {
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 400,
    letterSpacing: -14 * letterSpacingMultiplier.regular
  },
  BodySmallM: {
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 500,
    letterSpacing: -14 * letterSpacingMultiplier.medium
  },
  BodySmallSB: {
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 600,
    letterSpacing: -14 * letterSpacingMultiplier.semiBold
  },
  BodyLargeR: {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 400,
    letterSpacing: -16 * letterSpacingMultiplier.regular
  },
  BodyLargeM: {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 500,
    letterSpacing: -16 * letterSpacingMultiplier.medium
  },
  BodyLargeSB: {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 600,
    letterSpacing: -16 * letterSpacingMultiplier.semiBold
  },
  SubheadlineLargeR: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 400,
    letterSpacing: -20 * letterSpacingMultiplier.regular
  },
  SubheadlineLargeM: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 500,
    letterSpacing: -20 * letterSpacingMultiplier.medium
  },
  SubheadlineLargeSB: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 600,
    letterSpacing: -20 * letterSpacingMultiplier.semiBold
  },
  HeadlineSmallR: {
    fontFamily: displayFontFamily,
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 400,
    letterSpacing: -24 * letterSpacingMultiplier.regular
  },
  HeadlineSmallM: {
    fontFamily: displayFontFamily,
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 500,
    letterSpacing: 0
  },
  HeadlineSmallSB: {
    fontFamily: displayFontFamily,
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 600,
    letterSpacing: 0
  },
  HeadlineLargeR: {
    fontFamily: displayFontFamily,
    fontSize: 32,
    lineHeight: "36px",
    fontWeight: 400,
    letterSpacing: 0
  },
  HeadlineLargeM: {
    fontFamily: displayFontFamily,
    fontSize: 32,
    lineHeight: "36px",
    fontWeight: 500,
    letterSpacing: 0
  },
  HeadlineLargeSB: {
    fontFamily: displayFontFamily,
    fontSize: 32,
    lineHeight: "36px",
    fontWeight: 600,
    letterSpacing: 0
  },
  TitleSmallR: {
    fontFamily: displayFontFamily,
    fontSize: 40,
    lineHeight: "44px",
    fontWeight: 400,
    letterSpacing: 0
  },
  TitleSmallM: {
    fontFamily: displayFontFamily,
    fontSize: 40,
    lineHeight: "44px",
    fontWeight: 500,
    letterSpacing: 0
  },
  TitleSmallSB: {
    fontFamily: displayFontFamily,
    fontSize: 40,
    lineHeight: "44px",
    fontWeight: 600,
    letterSpacing: 0
  },
  TitleLargeR: {
    fontFamily: displayFontFamily,
    fontSize: 56,
    lineHeight: "60px",
    fontWeight: 400,
    letterSpacing: 0
  },
  TitleLargeM: {
    fontFamily: displayFontFamily,
    fontSize: 56,
    lineHeight: "60px",
    fontWeight: 500,
    letterSpacing: 0
  },
  TitleLargeSB: {
    fontFamily: displayFontFamily,
    fontSize: 56,
    lineHeight: "60px",
    fontWeight: 600,
    letterSpacing: 0
  },
  noOverflow: {
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  noWrap: {
    whiteSpace: "nowrap"
  },
  Regular: {
    fontWeight: 400
  },
  Medium: {
    fontWeight: 500
  },
  SemiBold: {
    fontWeight: 600
  },
  /** @deprecated Only SemiBold should be used, but updating `Bold` here to `600` while we remove usage in dashboard */
  Bold: {
    fontWeight: 600
  },
  /**
   * Sets [`font-variant-numeric`](https://developer.mozilla.org/en-US/docs/Web/CSS/font-variant-numeric) to `tabular-nums`, the set of figures where numbers are all of the same size, allowing them to be easily aligned like in tables.
   * */
  tabularNums: {
    fontFeatureSettings: "'tnum' on"
  },
  underline: {
    default: {
      textDecoration: "underline",
      textDecorationThickness: 1.5
    },
    dotted: {
      textDecoration: "underline",
      textDecorationStyle: "dotted",
      textDecorationThickness: 1.5
    }
  }
};

// src/zIndex.ts
var zIndex = {
  underground: -100,
  base: 0,
  boost: 100,
  sticky: 1e3,
  stickyHeader: 1001,
  sidepanel: 1999,
  mobileNavbar: 2e3,
  // Mobile navbar needs to be below overlay for details panes.
  hotspotPopover: 3e3,
  overlay: 4e3,
  navbar: 5e3,
  // Desktop navbar needs to be above overlay for dropdown menus rendered by nav.
  sidepanelMask: 5999,
  modalMask: 6999,
  modal: 7e3,
  popover: 8e3,
  tooltip: 9e3,
  goku: 9001
};
export {
  animationDurationMs,
  animations,
  borders,
  darkTheme,
  lightTheme,
  palette_exports as palette,
  shadows,
  spacing,
  typography,
  zIndex
};
